import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18a0fe40")

_pushScopeId("data-v-18a0fe40")
const _hoisted_1 = { class: "relative items-center flex" }
const _hoisted_2 = {
  key: 0,
  class: "left-search"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M15.1678 13.6349L14.4014 14.4014L13.6349 15.1678L17.4671 19L19 17.4671L15.1678 13.6349Z",
    fill: "#333333"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M12.1021 12.1021C14.6418 9.56231 14.6418 5.44456 12.1021 2.90481C9.56231 0.365062 5.44456 0.365062 2.90481 2.90481C0.365062 5.44456 0.365062 9.56231 2.90481 12.1021C5.44456 14.6418 9.56231 14.6418 12.1021 12.1021ZM12.1021 12.1021L14.4014 14.4014M14.4014 14.4014L15.1678 13.6349L19 17.4671L17.4671 19L13.6349 15.1678L14.4014 14.4014Z",
    stroke: "#333333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = {
  key: 2,
  class: "m-3 icon-time"
}
const _hoisted_5 = {
  key: 3,
  class: "icon-search"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.8536 17.1464L13.9994 13.2923C15.2445 11.882 16 10.0292 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C10.0292 16 11.882 15.2445 13.2923 13.9994L17.1464 17.8536C17.3417 18.0488 17.6583 18.0488 17.8536 17.8536C18.0488 17.6583 18.0488 17.3417 17.8536 17.1464ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z",
    fill: "#999999"
  })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "text-error-detail"
}
const _hoisted_8 = { class: "text-error" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        class: "absolute pl-2",
        src: _ctx.icon
      }, null, 8, ["src"]),
      (_ctx.leftSearch)
        ? (_openBlock(), _createBlock("span", _hoisted_2, [
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createVNode("input", {
        readonly: _ctx.readonly,
        disabled: _ctx.disabled,
        type: _ctx.type,
        name: "element-input",
        id: "element-input",
        placeholder: _ctx.placeholder,
        style: {
          paddingLeft: _ctx.icon ? '3rem' : undefined,
          borderRadius: _ctx.radius,
          paddingRight: _ctx.iconTime || _ctx.iconSearch ? '2rem' : undefined,
          background: _ctx.readonly ? '#efefef' : '',
          cursor: _ctx.readonly ? 'default' : '',
          width: _ctx.width,
        },
        class: ["block w-full shadow-sm truncate md:text-base input-wrapper lg:text-base sm:text-sm sm:h-8 md:h-12 lg:h-12 left-auto", _ctx.classes],
        value: _ctx.modelValue,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChangeInput && _ctx.onChangeInput(...args))),
        max: _ctx.max,
        min: _ctx.min
      }, null, 46, ["readonly", "disabled", "type", "placeholder", "value", "max", "min"]),
      (_ctx.iconPassword)
        ? (_openBlock(), _createBlock("span", {
            key: 1,
            class: ["cp-icon-eye icon-password pl-2", _ctx.classes],
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPassword && _ctx.showPassword(...args)))
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.iconTime)
        ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.t('time')), 1))
        : _createCommentVNode("", true),
      (_ctx.iconSearch)
        ? (_openBlock(), _createBlock("span", _hoisted_5, [
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    ((_ctx.validated || _ctx.firstEnter) && (_ctx.errorMessage || _ctx.errorServer))
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("span", null, _toDisplayString(_ctx.errorMessage || _ctx.errorServer), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})